module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"商品オプション別レビューを見る","description":"*表示されているレビュー数は計算時点によって実際のレビュー数と異なる場合があります。"}}')
  delete Component.options._Ctor
}
